import { AuthActionsUnion, AuthActionTypes } from '../actions/auth.actions';

export interface State {
  loggedIn: boolean;
}

export const initialState: State = {
  loggedIn: false
};

export function reducer(state = initialState, action: AuthActionsUnion): State {
  switch (action.type) {

    case AuthActionTypes.LoginSuccess: {
      return {
        ...state,
        loggedIn: true
      };
    }

    case AuthActionTypes.Logout: {
      return {
        ...state,
        loggedIn: false
      };
    }

    default: {
      return state;
    }
  }
}
